module.exports = __webpack_public_path__ + "img/joining-the-team.826bc809.png";